import type { LeaseActionProps } from '../../../models/Types';
import RequestLeaseExtensionSignatureModal from '../../RequestLeaseExtensionSignatureModal';

export default function OpenModalRequestSignatureLeaseExtension(props: LeaseActionProps) {
  return <RequestLeaseExtensionSignatureModal {...props} />;
}
